import { isEmpty, isNil } from "lodash-es";
import { config } from "~/config";
import { getChainKey, getContract } from "~/Provider/ChainKeyMaps";
import { TokenBase, TokenWithBalance } from "~/types";
import { skdUtils } from "~/utils/tgLink";

export const isSameToken = (
    token: Partial<TokenWithBalance> | null | undefined,
    anotherToken: Partial<TokenWithBalance> | null | undefined
) => {
    return (
        String(token?.token_base?.chain_id) ===
            String(anotherToken?.token_base?.chain_id) &&
        token?.token_base?.contract.toLowerCase() ===
            anotherToken?.token_base?.contract.toLowerCase()
    );
};

export const BUILT_IN_CONTRACT = "0x0000000000000000000000000000000000000000";
export const isBuiltInToken = (contract: string | null | undefined) => {
    return contract === BUILT_IN_CONTRACT;
};
export const isValidToken = (token_base?: TokenBase) => {
    return (
        !isNil(token_base) &&
        !isNil(token_base.chain_id) &&
        !isEmpty(token_base.contract) &&
        !isEmpty(token_base.symbol) &&
        !isEmpty(token_base.chain_name)
    );
};

const DEFAULT_SLIPPAGE = 1; // 1%
const SLIPPAGE_PERCISION = 10_000;
export const caculateSlippageValue = (value: string | null | undefined) => {
    const minimalSlippage = 0.1 * SLIPPAGE_PERCISION;
    const defaultSlippage = DEFAULT_SLIPPAGE * SLIPPAGE_PERCISION;

    if (value == null) {
        return defaultSlippage;
    }

    const slippageNum = Number(value);
    if (Number.isNaN(slippageNum)) {
        return defaultSlippage;
    }

    if (slippageNum * SLIPPAGE_PERCISION < minimalSlippage) {
        return minimalSlippage;
    }

    return slippageNum * SLIPPAGE_PERCISION;
};

export const buildTokenCurrecncyIcon = (
    tokenSymbol: string,
    isDark: boolean
) => {
    const urlPrefix = `${config.cdn_host}/chain/icon/${isDark ? "dark" : "light"}`;

    switch (true) {
        case /usdt/i.test(tokenSymbol):
            return `${urlPrefix}/usdt.svg`;
        case /usdc|usdbc/i.test(tokenSymbol):
            return `${urlPrefix}/usdc.svg`;
        case /btc/i.test(tokenSymbol):
            return `${urlPrefix}/btc.svg`;
        case /dai/i.test(tokenSymbol):
            return `${urlPrefix}/dai.svg`;
        case /eth/i.test(tokenSymbol):
            return `${urlPrefix}/ethereum.svg`;
        case /sol/i.test(tokenSymbol):
            return `${urlPrefix}/solana.svg`;
        case /bnb/i.test(tokenSymbol):
            return `${urlPrefix}/bnbchain.svg`;
        case /pol/i.test(tokenSymbol):
            return `${urlPrefix}/polygon.svg`;
        case /merl/i.test(tokenSymbol):
            return `${urlPrefix}/merlin.svg`;
        case /arb/i.test(tokenSymbol):
            return `${urlPrefix}/arbitrum.svg`;
        case /avax/i.test(tokenSymbol):
            return `${urlPrefix}/avalanchec.svg`;
        case /core/i.test(tokenSymbol):
            return `${urlPrefix}/core.svg`;
        case /zkl/i.test(tokenSymbol):
            return `${urlPrefix}/zklink.svg`;
        case /ape/i.test(tokenSymbol):
            return `${urlPrefix}/apecoin.svg`;
        default:
            return null;
    }
};

export const getWalletReceiveLink = (
    chain_id: string | number,
    contract: string
) => {
    const chain_key = getChainKey(chain_id);
    const token_addr = getContract(contract);

    const params = {
        path: `/receive-qr`,
        token_addr: token_addr,
        chain_key: chain_key,
        /** 开启 wallet replace 模式，不保留返回按钮 */
        route_replace: "1",
    };

    return `${config.wallet_direct_link}?startapp=D_${skdUtils.encodeTelegramUrlParameters(params || {})}`;
};
